module.exports = __webpack_public_path__ + "img/full1-min.960869c4.png";